/* eslint-disable import/no-named-default */
import angular from 'angular';
import controller from './app-version-dialog.controller';
import template from './app-version-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  ssDialogService,
} = library;

class dialogService {
  getOptions($event, { apiVersion, uiVersion, isUpToDate }) {
    return {
      controller,
      controllerAs: 'appVersionDialogVM',
      locals: {
        apiVersion,
        uiVersion,
        isUpToDate
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.appVersionDialog', [
  ssDialogService,
])
  .service('appVersionDialog', dialogService)
  .name;
